import { SwipeableDrawer } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(SwipeableDrawer)(() => ({
	'.MuiDrawer-paper': {
		display: 'grid',
		gridTemplateRows: 'max-content 1fr',

		height: '100%',
		width: '100vw',
	},
}));

export const Header = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr', // Allow title to take remaining space
	gridGap: 8,
	alignItems: 'center',
	justifyContent: 'start',
	width: '100%',
	minWidth: 0, // Allow grid items to shrink

	background: theme.palette.neutral[0],

	padding: '16px 32px',
	boxSizing: 'border-box',
}));

export const Content = styled('div')(({ theme }) => ({
	background: theme.palette.neutral[40],
	overflow: 'auto',
}));
